import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import $ from "jquery"

import Pathname from '../components/Pathname';
import Permission from '../components/Permission';

import DocumentSidebar from '../components/DocumentSidebar';
import SettingSidebar from '../components/SettingSidebar';
import ReportSidebar from '../components/ReportSidebar';
import DepartmentGroupsSettingSidebar from '../components/DepartmentGroupsSettingSidebar';

export default class Header extends Component {
  render(){
    var prefixPathname = Pathname.prefixPathname(this.props.location);
    const { siteSetting } = this.props;

    let feedback_url = "#";
    switch(siteSetting.code_name) {
      case "RMUTI":
        feedback_url = "https://goo.gl/w1VYq4";
        break;
      case "RMUTI_SKC":
        feedback_url = "https://goo.gl/R6zihq";
        break;
      case "RMUTI_KKC":
        feedback_url = "https://goo.gl/bexAQj";
        break;
      case "RMUTI_SURIN":
        feedback_url = "https://goo.gl/VCM8yu";
        break;
    }

    return(
      <header>
        <nav className='navbar navbar-expand-lg navbar-dark' style={{backgroundColor: '#315a7d'}}>
          <a className="navbar-brand" href="/documents/mydoc">
            {/*_.get(this.props.siteSetting, 'name', '')*/}
          </a>
          <button className='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarNav' aria-controls='navbarNav' aria-expanded='false' aria-label='Toggle navigation'>
            <span className='navbar-toggler-icon'></span>
          </button>
          <div className='collapse navbar-collapse ml-lg-5 pl-lg-5' id='navbarNav'>
            <ul className="navbar-nav font-weight-bold ml-lg-5 mr-auto">
              <li className='nav-item px-3'>
                <Link to='/documents/mydoc' className={`nav-link ${(prefixPathname === 'documents' || prefixPathname === '') && 'active'}`}>สารบรรณ</Link>
                <div className="d-lg-none"><DocumentSidebar location={this.props.location} /></div>
              </li>
              <li className='nav-item px-3'>
                <Link to='/storages' className={`nav-link ${(prefixPathname === 'storages') && 'active'}`}>ระบบจัดเก็บ</Link>
              </li>
              <li className='nav-item px-3'>
                <Link to='/organizations' className={`nav-link ${(prefixPathname === 'organizations') && 'active'}`}>แผนผังองค์กร</Link>
              </li>
              <li className='nav-item px-3'>
                <Link to='/reports/usage_report' className={`nav-link ${(prefixPathname === 'reports') && 'active'}`}>รายงาน</Link>
                <div className="d-lg-none"><ReportSidebar location={this.props.location} /></div>
              </li>
              <li className='nav-item px-3'>
                <Link to='/manuals' className={`nav-link ${(prefixPathname === 'manuals') && 'active'}`}>คู่มือการใช้งาน</Link>
              </li>
              {Permission.isAdmin() && (
                <li className='nav-item px-3'>
                  <Link to='/department_groups_settings/department_groups' className={`nav-link ${(prefixPathname === 'department_groups_settings') && 'active'}`}>ตั้งค่ากลุ่มสารบรรณ</Link>
                  <div className="d-lg-none"><DepartmentGroupsSettingSidebar location={this.props.location} /></div>
                </li>
              )}
              {Permission.isAdmin() && (
                <li className='nav-item px-3'>
                  <Link to='/settings/sitesetting' className={`nav-link ${(prefixPathname === 'settings') && 'active'}`}>ตั้งค่า</Link>
                  <div className="d-lg-none">
                    <SettingSidebar location={this.props.location} siteSetting={siteSetting} />
                  </div>
                </li>
              )}
              {!Permission.isAdmin() && Permission.isSuperAdmin() && (
                <li className='nav-item px-3'>
                  <Link to='/settings/setup' className={`nav-link ${(prefixPathname === 'settings') && 'active'}`}>ตั้งค่า</Link>
                  <div className="d-lg-none">
                    <SettingSidebar location={this.props.location} siteSetting={siteSetting}/>
                  </div>
                </li>
              )}
              {(Permission.isSecretary() || Permission.isCorrespondence()) && (
                <li className='nav-item px-3'>
                  <Link to='/settings/actings' className={`nav-link ${(prefixPathname === 'settings') && 'active'}`}>ตั้งค่า</Link>
                  <div className="d-lg-none">
                    <SettingSidebar location={this.props.location} siteSetting={siteSetting}/>
                  </div>
                </li>
              )}
            </ul>
            <ul className="navbar-nav">
              <li className='nav-item'>
                <a href={feedback_url} target="_blank" rel="noopener noreferrer" className="nav-link btn btn-light text-danger">
                  แบบประเมิน
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    )
  }
}

$(document).ready(function(){
  $(document).on('click', '.navbar-collapse a', function(){
    $(".navbar-collapse").removeClass('show');
  });
})




// WEBPACK FOOTER //
// ./src/layouts/Header.js